import { Component } from '@angular/core';

@Component({
  selector: 'app-aprobaciones-minuta',
  templateUrl: './aprobaciones-minuta.component.html',
  styleUrls: ['./aprobaciones-minuta.component.scss']
})
export class AprobacionesMinutaComponent {

}
